import { render, staticRenderFns } from "./LimitTime.vue?vue&type=template&id=6d9d9e53&"
import script from "./LimitTime.vue?vue&type=script&lang=js&"
export * from "./LimitTime.vue?vue&type=script&lang=js&"
import style0 from "./LimitTime.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports